module.exports = __webpack_public_path__ + "img/cargo-wagon-shadow-3.452904f7.png";